import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../lib/Errors';

let localSubscription = undefined;

function createSubscription(store) {
	let dataQuery = new Parse.Query('MedicationClass');
	dataQuery.find()
		.then((results) => {
			store.dispatch('medicationClass/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			
		});
		dataQuery.subscribe().then((subscription) => {
		
		localSubscription = subscription;

		subscription.on('create', object => {
			
			store.dispatch('medicationClass/insert', object)
		});
		subscription.on('update', object => {
			
			store.dispatch('medicationClass/replace', object)
		});
		subscription.on('enter', object => {
			
			store.dispatch('medicationClass/insert', object)
		});
		subscription.on('leave', object => {
			
			store.dispatch('medicationClass/delete', object)
		});
		subscription.on('delete', object => {
			
			store.dispatch('medicationClass/delete', object)
		});
		subscription.on('close', () => {
			
		});
		subscription.on('error', error => {
			
		})
	})
}

export default function createMedicationClassSubscription() {
	return store => {
		if (store.state.currentUser) {
			createSubscription(store)
		}
		store.subscribe(mutation => {
			if (mutation.type === 'SET_CURRENT_USER') {
				if (localSubscription) {
					localSubscription.unsubscribe()
				}
				if (store.state.currentUser) {
					createSubscription(store)
				}
			}
		})
	}
}
